import { render, staticRenderFns } from "./InfoSwallow.vue?vue&type=template&id=d76174f4&scoped=true&"
import script from "./InfoSwallow.vue?vue&type=script&lang=js&"
export * from "./InfoSwallow.vue?vue&type=script&lang=js&"
import style0 from "./InfoSwallow.vue?vue&type=style&index=0&id=d76174f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76174f4",
  null
  
)

export default component.exports